<template>
    <div>
        <div v-if="nodeNow < 4">
            <div>
                <el-link v-if="hasSignUp" class="teamManage"
                    @click="() => teamDialogVisible = true"
                >我的队伍 ></el-link>
            </div>
            <el-button type="primary" v-if="nodeNow == 0"
                :disabled="hasSignUp" @click="handleSignUp"
            >{{ hasSignUp ? "已报名, 等待比赛开始" : "报名参加" }}</el-button>
            <el-button type="primary" v-else-if="hasSignUp || nodeNow == 1"
                @click="() => (hasSignUp ? enterTower() : handleSignUp())"
            >{{ hasSignUp ? "进入比赛" : "报名参加" }}</el-button>
            <br/>
            <span :style="{ color: '#AAAAAA' }">当前成绩: {{ score }}</span>
        </div>
        <div v-if="nodeNow > 0 && nodeNow < 4" class="processbar">
            <el-progress :percentage="percentage"
                :format="format" :color="color"
            ></el-progress>
        </div>
        <div class="table">
            <el-table
                :data="rankData"
                style="width: 100%"
                :row-class-name="highlightself"
            >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column 
                    prop="name" label="队伍名称" width="180"
                ></el-table-column>
                <el-table-column
                    prop="players" label="队员" width="200"
                >
                    <template slot-scope="scope">
                        <el-link target="_blank"
                            :href="'https://h5mota.com/user/user.php?uid='+scope.row.leader.id"
                        >{{ scope.row.leader.name }}</el-link>
                        <el-link v-if="scope.row.member" class="teammemberlink" target="_blank"
                            :href="'https://h5mota.com/user/user.php?uid='+scope.row.member.id"
                        >{{ scope.row.member.name }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hp" label="当前hp" width="100"
                ></el-table-column>
                <el-table-column
                    prop="point" label="累计系数" width="100"
                ></el-table-column>
            </el-table>
        </div>
        <el-dialog width="360px" title="报名参加" :visible.sync="signDialogVisible">
            <div class="signform">
                <el-input v-model="teamName" placeholder="队伍名"></el-input>
                <el-button @click="handleCreateTeam(teamName)">创建队伍</el-button>
                <p>或</p>
                <el-input v-model="inviteCode" placeholder="邀请码"></el-input>
                <el-button @click="handleJoinTeam(inviteCode)">加入队伍</el-button>
            </div>
        </el-dialog>
        <el-dialog width="360px" title="队伍管理" :visible.sync="teamDialogVisible">
            <TeamManage/>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="handleQuitTeam()"
                    :disabled="nodeNow > 1"
                >退出队伍</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import TeamManage from './TeamManage.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {
            teamName: "",
            inviteCode: "",
            teamDialogVisible: false,
            signDialogVisible: false,
        }
    },
    computed: {
        ...mapState([ "hasLogin", "userid" ]),
        ...mapState("$main", [ "hasSignUp", "score" ]),
        ...mapGetters("$main", [ "nodeNow", "next", "rankData" ]),
        color() {
            switch(this.nodeNow) {
                case 3: return "#f56c6c";
                case 4: return "#67c23a";
                default: return '#409eff';
            }
        },
        percentage() {
            switch(this.nodeNow) {
                case 2: 
                    if (this.next < 24 * 3600) {
                        return 68;
                    } else {
                        return 88;
                    }
                case 3: 
                    return 48 - 4 * Math.floor(this.next / 3600);
                case 4: return 0;
                default: return 100;
            }
        }
    },
    methods: {
        ...mapActions([ "openLoginDialog" ]),
        ...mapActions("$main", [ "createTeam", "joinTeam", "quitTeam", "getRankList" ]),
        format(percentage) {
            return percentage * 5;
        },
        async handleSignUp() {
            if (!this.hasLogin) {
                await this.openLoginDialog();
                if (this.hasLogin) this.handleSignUp();
            } else {
                this.signDialogVisible = true;
            }
        },
        handleCreateTeam(teamName) {
            if (teamName.length == 0) {
                this.$message.warning("队伍名不能为空");
                return;
            }
            this.createTeam({ teamName }).then(() => {
                setTimeout(() => {
                    if (this.hasSignUp) {
                        this.signDialogVisible = false;
                    }
                }, 10);
            })
        },
        handleJoinTeam(inviteCode) {
            if (inviteCode.length == 0) {
                this.$message.warning("请输入验证码");
                return;
            }
            this.joinTeam({ inviteCode }).then(() => {
                setTimeout(() => {
                    if (this.hasSignUp) {
                        this.signDialogVisible = false;
                    }
                }, 10);
            })
        },
        handleQuitTeam() {
            this.$confirm('确定退出队伍?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.quitTeam().then(() => {
                    setTimeout(() => {
                        if (!this.hasSignUp) {
                            this.teamDialogVisible = false;
                        }
                    }, 10);
                });
            })
        },
        highlightself({ row }) {
            if (row.leader.id == this.userid || row.member?.id == this.userid) {
                return "self-highlight";
            } else {
                return "";
            }
        },
        enterTower() {
            window.open("mota.pw/Another1");
        }
    },
    watch: {
        nodeNow() {
            setTimeout(() => {
                this.getRankList();
            }, 30 * 1000);
        }
    },
    components: {
        TeamManage
    }
}
</script>

<style lang="less">
.el-table .self-highlight {
    background: #f5f7fa;
}
.el-progress-bar__outer {
    transform: rotateY(180deg);
}
</style>

<style lang="less" scoped>
.teamManage {
    margin-left: 65%;
}
.table {
    max-width: 640px;
    margin: auto;
}
.signform {
    padding: 5px;
    .el-input {
        padding: 5px;
    }
}
.teammemberlink {
    margin-left: 8px;
}
.processbar {
    margin: 10px;
    margin-top: 15px;
}
</style>